export default __webpack_public_path__ + "static/media/cheatday@3x.2b85dbe5.jpg";